export default __webpack_public_path__ + "static/media/Opmax-20-Cap-ban.e0f1d1fe.jpg";